import { supabase } from '../lib/supabase';

export async function submitReview(productId, customerName, rating, comment) {
  const { data, error } = await supabase
    .from('product_reviews')
    .insert({ product_id: productId, customer_name: customerName, rating, comment, status: 'pending' })
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function listApprovedReviews(productId) {
  const { data, error } = await supabase
    .from('product_reviews')
    .select('*')
    .eq('product_id', productId)
    .eq('status', 'approved')
    .order('created_at', { ascending: false });
  if (error) throw error;
  return data || [];
}

// Admin operations (require admin RLS)
export async function listPendingReviews(productId) {
  const query = supabase
    .from('product_reviews')
    .select('*')
    .eq('status', 'pending')
    .order('created_at', { ascending: false });
  if (productId) query.eq('product_id', productId);
  const { data, error } = await query;
  if (error) throw error;
  return data || [];
}

export async function approveReview(reviewId, adminReply) {
  const { data, error } = await supabase
    .from('product_reviews')
    .update({ status: 'approved', admin_reply: adminReply ?? null })
    .eq('id', reviewId)
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function rejectReview(reviewId) {
  const { data, error } = await supabase
    .from('product_reviews')
    .update({ status: 'rejected' })
    .eq('id', reviewId)
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function updateAdminReply(reviewId, adminReply) {
  const { data, error } = await supabase
    .from('product_reviews')
    .update({ admin_reply: adminReply ?? null })
    .eq('id', reviewId)
    .select()
    .single();
  if (error) throw error;
  return data;
}


